// import APIs
import {
  getCostCenterDuties,
  type CostCenterDuty
} from 'RestAPIs/employees/hours-table/duties';

// import external libraries
import { useState } from 'react';
import { useQuery } from 'react-query';
import dayjs from 'dayjs';

interface UseGetCostCenterDutiesParams {
  date?: string;
  organizationalUnitId?: number;
}

const useGetCostCenterDuties = ({
  date,
  organizationalUnitId
}: UseGetCostCenterDutiesParams) => {
  const [showAll, setShowAll] = useState(false);

  const startDate = dayjs(date).startOf('day').toISOString();
  const endDate = dayjs(date).endOf('day').toISOString();

  const params =
    organizationalUnitId !== undefined
      ? {
          startDate,
          endDate,
          onlyPreferred: !showAll,
          costCenters: organizationalUnitId
        }
      : { startDate, endDate, onlyPreferred: false };

  const { data, isFetching, isError } = useQuery(
    ['costCenterDuties', date, organizationalUnitId ?? null, showAll],
    async () => {
      const { data } = await getCostCenterDuties(params);
      return data;
    },
    { enabled: !!date }
  );

  let duties: CostCenterDuty[] = data ?? [];

  if (showAll) {
    duties = [...duties].sort((a, b) => {
      if (a.preferred === b.preferred) return 0;
      return a.preferred ? -1 : 1;
    });
  }

  return { duties, showAll, setShowAll, isFetching, isError };
};

export default useGetCostCenterDuties;
